import { ChatbotState } from '~/types/chatbot';
import { UseChatbotMonarchReturnType } from '../useChatbotMonarch';

export type ChatbotViewState =
  | { type: 'LOADING' }
  | { type: 'DISABLED' }
  | { type: 'GIGA_ENABLED'; props: ChatbotProps }
  | { type: 'PROACTIVE_V1_ENABLED'; props: ChatbotProps }
  | { type: 'PROACTIVE_V2_ENABLED'; props: ChatbotProps };

export interface ChatbotProps {
  firebase: unknown;
  visible: boolean;
  currentPage: string;
  sdkVersion: string;
}

/**
 * Derives the current view state based on Monarch flags and chatbot state
 */
export const deriveViewState = (
  monarchFlags: UseChatbotMonarchReturnType,
  chatbotState: ChatbotState,
  firebase: unknown,
  currentPage: string
): ChatbotViewState => {
  // Loading state
  if (monarchFlags.isLoading) {
    return { type: 'LOADING' };
  }

  const chatType = monarchFlags.chatType;

  // Disabled state
  if (!chatType) {
    return { type: 'DISABLED' };
  }

  const visible = chatbotState.status === 'GIGA_CHAT_VISIBLE' || chatbotState.status === 'PROACTIVE_CHAT_VISIBLE';

  const props: ChatbotProps = {
    firebase,
    visible,
    currentPage,
    sdkVersion: monarchFlags.sdkVersion,
  };

  // Return appropriate view state
  if (chatType === 'Giga') {
    return { type: 'GIGA_ENABLED', props };
  }

  if (chatType === 'ProactiveV2') {
    return { type: 'PROACTIVE_V2_ENABLED', props };
  }

  if (chatType === 'Proactive') {
    return { type: 'PROACTIVE_V1_ENABLED', props };
  }

  return { type: 'DISABLED' };
};

/**
 * Extracts chatbot props from view state (null if disabled/loading)
 */
export const getChatbotProps = (viewState: ChatbotViewState): ChatbotProps | null => {
  if (viewState.type === 'DISABLED' || viewState.type === 'LOADING') {
    return null;
  }
  return viewState.props;
};
